import { ProjectDto } from '@/core';

export const validateRolesTab = (projectData: ProjectDto) => {
  return !!projectData.positions.length;
};
